import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import * as actions from "./actions";

function* fetchThreeCardCustomReading() {
  try {
    const result = yield call(AxiosCall, `/tarot/get_threecardcustomreading/`);
    const { count, results } = result.data;
    yield put(actions.fetchThreeCardCustomReadingSuccess(count, results));
  } catch (e) {
    yield put(actions.fetchThreeCardCustomReadingFailure(e.message));
  }
}

function* createThreeCardCustomReading(action) {
  try {
    const { question, cards, orientations, gift } = action.payload;

    // First-contact campaign path: when the user comes in via ?gift=1 from
    // the blocked-page register flow, hit the gift redemption endpoint
    // instead of the regular paid-credit one.
    if (gift) {
      const result = yield call(AxiosPost, "/tarot/redeem_gift/", {
        question,
        cards_ids: cards,
        orientations: orientations || [],
      });
      if (!result?.data?.verified) throw new Error('No pudimos canjear tu regalo');
      yield put(actions.createThreeCardCustomReadingSuccess(true));
      return;
    }

    const result = yield call(AxiosPost, "/tarot/create_threecardcustomreading/", {
      question,
      cards_ids: cards,
      orientations: orientations || [],
    });

    if (result.data.response !== "READING_ACCEPTED")
      throw new Error('Ya realizaste tu consulta diaria')

    yield put(actions.createThreeCardCustomReadingSuccess(true));
  } catch (e) {
    // Extract structured error if backend returned 403 gift_requirements_unmet.
    // Shape: { error: "gift_requirements_unmet", failures: [{check, message, remediation}] }
    const data = e?.response?.data;
    if (data?.error === "gift_requirements_unmet") {
      yield put(actions.createThreeCardCustomReadingFailure(data));
    } else {
      yield put(actions.createThreeCardCustomReadingFailure(e));
    }
  }
}

export default function* threeCardReadingSaga() {
  yield all([
    // watchers reading
    takeEvery(actions.CREATE_THREECARDCUSTOMREADING_REQUEST, createThreeCardCustomReading),
    takeLatest(actions.FETCH_THREECARDCUSTOMREADING_REQUEST, fetchThreeCardCustomReading),
  ])
}